import { Card, Row, Col } from 'antd';
import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import BarComponent from './Charts/BarComponent';
import ChartLoading from './Charts/ChartLoading';
import { BAR_CHART, useChartData } from './Charts/config';
import { useRealtimeTap } from './data';

const RealtimeTap = () => {
  const { loading, taps } = useRealtimeTap();
  const barData = useChartData({ data: taps, type: BAR_CHART, label: '' });
  return (
    <Auxiliary>
      <Card className="gx-card gx-p-15 gx-text-center" title="Pergerakan Pekerja Setiap Hari">
        {loading ? <ChartLoading /> : <BarComponent data={barData} type="vertical" />}
      </Card>
    </Auxiliary>
  );
}

export default RealtimeTap;